module.exports = __webpack_public_path__ + "static/media/fiber.d330e182.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/kits/fiber.jpg
// module id = 212
// module chunks = 0